<template>
	<card>
		<ReFormPrinter 
			:masFormConfig="masAllFormParams" 
			:objSaveApiMethod="currentApiFormMethod"
			:SuccessGo="SuccessGo"/>
	</card>
</template>

<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
	export default {
		name: 'ReBPStageEdit',
		components: {
			ReFormPrinter
		},
		props: {
			stageId: {
				type: String, 
				default: '-1'
			},
			operationType: String, 
		},
		data () {
			return {
				ver: 1,
				masAllFormParams: this.currentFormConfig(),
			}
		},
		computed: {
			currentApiFormMethod: function(){
				if(this.operationType == 'edit'){
					return {apiMethod:'UPD_STAGE',apiParam:{obj:'BP' ,flt:{bp_id:this.$route.params.bp_id,id:this.stageId},uData:[]}};
				} else if(this.operationType == 'add'){
					return {apiMethod:'ADD_STAGE',apiParam:{obj:'BP' ,flt:{bp_id:this.$route.params.bp_id},iData:[]}};
				}
				return {apiMethod:'UPD_STAGE',apiParam:{obj:'BP' ,flt:{bp_id:this.$route.params.bp_id,id:this.stageId},uData:[]}};
			}
		},
		methods: {
			currentFormConfig(){
				if(this.operationType == 'edit'){
					this.$GVO.ApiCall('GET_FORM_BP_STAGE',{obj:'BP',flt:{id:this.stageId,bp_id:this.$route.params.bp_id} })
						.then((objApi) => {
							if(objApi.success === true){
								//console.log(objApi);
								this.masAllFormParams = objApi.config;
							}
						}).catch(errorObjApi => console.error(errorObjApi));
				} else if(this.operationType == 'add'){
					this.$GVO.ApiCall('GET_FORM_BP_STAGE',{obj:'BP',flt:{id:0,bp_id:this.$route.params.bp_id,after:this.$GVO.GetGetVar('add_after')} })
						.then((objApi) => {
							if(objApi.success === true){
								//console.log(objApi);
								this.masAllFormParams = objApi.config;
							}
						}).catch(errorObjApi => console.error(errorObjApi));
				}
				return [];
			},
			SuccessGo(evt){
				if(this.operationType == 'edit'){
					this.$router.push({path: this.$GVO.str_replace('/edit/stage/'+this.stageId,'',evt)});
				}else if(this.operationType == 'add'){
					this.$router.push({path: this.$GVO.str_replace('/add/stage','',evt)});
				}
			},
		},
	}
</script>
<style scoped>

</style>
